import { GuardedComponent } from '../components/guarded-component';
import EmployeeProfilePage from '../features/masters/employee/profile/employee-profile.page';
import { UserPermissionName } from '../models/user-permission-name';

export const EmployeeProfileRoute = {
  path: '/employee/profile/:id',
  name: 'Employee Profile',
  element: (
    <GuardedComponent requiredPermissions={[UserPermissionName.DISPLAY_PROFILE]} showPermissionError>
      <EmployeeProfilePage />
    </GuardedComponent>
  ),
};
